export default "__VITE_ASSET__De60Qax5__"